import React from "react";
import { Autocomplete, CircularProgress } from "@mui/material";
import { styled } from "@mui/styles";
import VSNFormControl from "./VSNFormControl";
import VSNTextField from "./VSNTextField";

const StyledAutocomplete = styled(Autocomplete)({
  "& .MuiInputBase-root": {
    fontWeight: 500,
    fontSize: 14,
    lineHeight: "23px",
    color: "#202024",
    "&.MuiInput-root .MuiInputBase-input": {
      padding: "8px 0",
    },
    "&.MuiOutlinedInput-root": {
      "& .MuiAutocomplete-input": {
        cursor: "pointer",
        padding: 0,
        fontSize: 14,
        fontWeight: 500,
      },
    },
    "&:focus": {
      background: "transparent",
    },
    "&::before": {
      borderBottom: "1px solid #CBCBCF !important",
    },
  },
  "& .MuiAutocomplete-popupIndicator": {
    "& path": {
      stroke: "var(--primary)",
    },
  },
  "& .MuiAutocomplete-paper": {
    maxHeight: 300,
  },
  "& .MuiPopover-root": {
    "& .MuiPaper-root": {
      position: "static",
    },
  },
});

const VSNMUIAutocomplete = ({
  value = 0,
  options = [],
  label,
  onChange,
  elementId,
  name,
  fullWidth,
  variant,
  classes,
  placeHolder,
  disabled = false,
  readOnly,
  formControlSx,
  loading,
  ...rest
}) => {
  return (
    <VSNFormControl fullWidth={fullWidth} sx={formControlSx}>
      <StyledAutocomplete
        value={options?.find((option) => option.value === value) || null}
        onChange={(event, newValue) => {
          onChange({
            target: { name, value: newValue?.value || "" },
          });
        }}
        options={options}
        getOptionLabel={(option) => option.key}
        isOptionEqualToValue={(option, value) => option.value === value.value}
        disabled={disabled || readOnly}
        loading={loading}
        fullWidth={fullWidth}
        {...rest}
        renderInput={(params) => (
          <VSNTextField
            {...params}
            label={label}
            placeholder={placeHolder}
            variant={variant}
            InputProps={{
              ...params.InputProps,
              endAdornment: (
                <>
                  {loading ? <CircularProgress size={20} /> : null}
                  {params.InputProps.endAdornment}
                </>
              ),
            }}
          />
        )}
      />
    </VSNFormControl>
  );
};

export default VSNMUIAutocomplete;
